"use client";

import { markFeedbackPopupShown } from "@/actions/feedback-prompt";
import { useAuth } from "@/contexts/AuthContext";
import { FeedbackPromptProvider } from "@/contexts/FeedbackPromptContext";
import { useCallback } from "react";

interface FeedbackPromptWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that provides feedback prompt tracking functionality.
 * Automatically determines if the user has seen the feedback popup from their profile.
 */
export function FeedbackPromptWrapper({
  children,
}: FeedbackPromptWrapperProps) {
  const { user } = useAuth();

  const handleFeedbackPopupShown = useCallback(async () => {
    // Persist to Firestore that the user has seen the feedback popup
    await markFeedbackPopupShown();
  }, []);

  // Check if user has already seen the feedback popup
  const hasSeenFeedbackPopup = Boolean(user?.feedbackPopupShownAt);

  return (
    <FeedbackPromptProvider
      hasSeenFeedbackPopup={hasSeenFeedbackPopup}
      onFeedbackPopupShown={handleFeedbackPopupShown}
    >
      {children}
    </FeedbackPromptProvider>
  );
}
